import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import fetchCategoryArticlesByCategoryId, {
  build as CategoryArticlesRequestKey,
  QueryParameters as ICategoryArticlesQueryParams,
} from "@faire/web-api--source/api/zendesk/locale/categories/categoryId/articles/get";
import { IZendeskCategory } from "@faire/web-api--source/com/faire/vendor/zendesk/IZendeskCategory";
import { useQueries } from "@tanstack/react-query";

export const useAllCategoryArticles = (categories: IZendeskCategory[]) => {
  const categoriesArticlesResponses = useQueries({
    queries: categories.map((category: IZendeskCategory) => {
      const categoryParams = ICategoryArticlesQueryParams.build({
        label_names:
          category.id === BRANDS_CATEGORY_ID
            ? "popular-maker"
            : "popular-retailer",
      });
      return {
        queryKey: [
          CategoryArticlesRequestKey(
            localeString,
            `${category.id}`,
            categoryParams
          ),
        ],
        queryFn: () =>
          fetchCategoryArticlesByCategoryId(
            localeString,
            `${category.id}`,
            categoryParams
          ),
        enable: categories.length > 0,
      };
    }),
  });
  const isLoading = categoriesArticlesResponses.some(
    (queryResult) => queryResult.isLoading
  );
  const allDataUpdatedAt = categoriesArticlesResponses.map(
    (queryResult) => queryResult.dataUpdatedAt
  );
  const dataUpdatedAt = getLatestDataUpdatedAt(allDataUpdatedAt);

  return {
    categoriesArticlesResponses,
    isCategoriesArticlesLoading: isLoading,
    categoriesArticlesDataUpdatedAt: dataUpdatedAt,
  };
};
